import { render, staticRenderFns } from "./UpdateClassifier.vue?vue&type=template&id=0b84c484&"
import script from "./UpdateClassifier.vue?vue&type=script&lang=js&"
export * from "./UpdateClassifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports